<template>
  <v-row>
    <v-col cols="12">
      <v-text-field label="Adresse" color="primary" v-model="adressLocal" />
    </v-col>
    <v-col cols="12" md="4">
      <v-text-field label="Cité" color="primary" v-model="cityLocal" />
    </v-col>
    <v-col cols="12" md="4">
      <v-combobox
        :items="items"
        label="Region"
        color="primary"
        v-model="countryLocal"
      ></v-combobox>
    </v-col>
    <v-col cols="12" md="4">
      <v-text-field
        label="Code Postale"
        color="primary"
        type="number"
        v-model="zipCodeLocal"
      />
    </v-col>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      items: [
        "Ariana",
        "Béja",
        "Ben Arous",
        "Bizerte",
        "Gabès",
        "Gafsa",
        "Jendouba",
        "Kairouan",
        "Kasserine",
        "Kebili",
        "Kef",
        "Mahdia",
        "Manouba",
        "Medenine",
        "Monastir",
        "Nabeul",
        "Sfax",
        "Sidi Bouzid",
        "Siliana",
        "Sousse",
        "Tataouine",
        "Tozeur",
        "Tunis",
        "Zaghouan",
      ],
    };
  },
  props: ["zipCode", "country", "city", "adress", "phone"],
  computed: {
    phoneLocal: {
      get() {
        return this.phone;
      },
      set(value) {
        this.$emit("update:phone", value);
      },
    },
    adressLocal: {
      get() {
        return this.adress;
      },
      set(value) {
        this.$emit("update:adress", value);
      },
    },
    cityLocal: {
      get() {
        return this.city;
      },
      set(value) {
        this.$emit("update:city", value);
      },
    },
    countryLocal: {
      get() {
        return this.country;
      },
      set(value) {
        this.$emit("update:country", value);
      },
    },
    zipCodeLocal: {
      get() {
        return this.zipCode;
      },
      set(value) {
        this.$emit("update:zipCode", value);
      },
    },
  },
};
</script>